import { PAGES } from '../lib/config';
import { FREE_FAQ } from '../lib/content';
import { ToolPageShell } from '../components/ToolPageShell';

export function FreeImageUpscalerPage() {
  const page = PAGES.find((p) => p.path === '/free-image-upscaler')!;
  const extra = (
    <>
      <h2 className="text-2xl font-bold text-text-primary">Free AI image upscaler</h2>
      <p>
        Upscale your images without paying or signing up. The free plan gives you 2 images per day
        at 2× resolution.
      </p>
      <h3 className="text-xl font-semibold text-text-primary">What is included for free</h3>
      <ul>
        <li>2 images per day</li>
        <li>2× upscale</li>
        <li>JPG, PNG, WebP support</li>
        <li>Fast AI processing</li>
      </ul>
      <h3 className="text-xl font-semibold text-text-primary">When to upgrade to Pro</h3>
      <p>
        Upgrade when you need 4× upscales, higher-resolution output, or more than 2 images per
        day.
      </p>
    </>
  );
  return <ToolPageShell page={page} faqItems={FREE_FAQ} extraContent={extra} />;
}
